/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Remove_Line_All_UppercaseInputs */

const en_remove_line_all_uppercase = /** @type {(inputs: Remove_Line_All_UppercaseInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Remove line if it's all uppercase`)
};

const fr_remove_line_all_uppercase = /** @type {(inputs: Remove_Line_All_UppercaseInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Supprimer la ligne si elle est en majuscules`)
};

const de_remove_line_all_uppercase = /** @type {(inputs: Remove_Line_All_UppercaseInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Zeile entfernen, falls sie nur aus Großbuchstaben besteht`)
};

const it_remove_line_all_uppercase = /** @type {(inputs: Remove_Line_All_UppercaseInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Rimuovi la riga se è tutta in maiuscolo`)
};

const ru_remove_line_all_uppercase = /** @type {(inputs: Remove_Line_All_UppercaseInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Удалите строку, если все буквы заглавные.`)
};

const es_remove_line_all_uppercase = /** @type {(inputs: Remove_Line_All_UppercaseInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Eliminar línea si está toda en mayúsculas`)
};

const zh_cn2_remove_line_all_uppercase = /** @type {(inputs: Remove_Line_All_UppercaseInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`如果全是大写字母，则删除该行。`)
};

const ja_remove_line_all_uppercase = /** @type {(inputs: Remove_Line_All_UppercaseInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`すべて大文字の場合は行を削除します`)
};

const hi_remove_line_all_uppercase = /** @type {(inputs: Remove_Line_All_UppercaseInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`यदि पंक्ति पूरी तरह से बड़े अक्षरों में है तो उसे हटा दें।`)
};

const pt_pt2_remove_line_all_uppercase = /** @type {(inputs: Remove_Line_All_UppercaseInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Remova a linha se estiver tudo em maiúsculas.`)
};

/**
* | output |
* | --- |
* | "Remove line if it's all uppercase" |
*
* @param {Remove_Line_All_UppercaseInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const remove_line_all_uppercase = /** @type {((inputs?: Remove_Line_All_UppercaseInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Remove_Line_All_UppercaseInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_remove_line_all_uppercase(inputs)
	if (locale === "de") return de_remove_line_all_uppercase(inputs)
	if (locale === "it") return it_remove_line_all_uppercase(inputs)
	if (locale === "ru") return ru_remove_line_all_uppercase(inputs)
	if (locale === "es") return es_remove_line_all_uppercase(inputs)
	if (locale === "zh-CN") return zh_cn2_remove_line_all_uppercase(inputs)
	if (locale === "ja") return ja_remove_line_all_uppercase(inputs)
	if (locale === "hi") return hi_remove_line_all_uppercase(inputs)
	if (locale === "pt-PT") return pt_pt2_remove_line_all_uppercase(inputs)
	return en_remove_line_all_uppercase(inputs)
});